<p class="section-description">
  Hover any target. The arrow must sit on the bubble's center line and point at the target it belongs to — PrimeNG
  measures the tooltip once, while it is parked offscreen, so anything that changes the bubble's width after that
  measurement drags the arrow off center.
</p>

<h3 class="modal-group-title">Style class × position</h3>
<p class="section-description">
  Each row carries its production hover options, so the two scrollable variants can be entered with the cursor and
  scrolled — the rest hide as soon as the host loses hover.
</p>
<div class="tooltip-matrix">
  @for (variant of tooltipVariants; track variant.key) {
    <div class="tooltip-matrix-row">
      <div class="tooltip-matrix-meta">
        <code class="tooltip-matrix-class">{{ variant.styleClass || '(none)' }}</code>
        <span class="tooltip-matrix-cap">{{ variant.cap }}</span>
        <span class="tooltip-matrix-note">{{ variant.note }}</span>
      </div>
      <div class="tooltip-matrix-targets">
        @for (position of tooltipPositions; track position.key) {
          <button
            type="button"
            class="tooltip-target"
            [pTooltip]="variant.content"
            [tooltipPosition]="position.key"
            [tooltipStyleClass]="variant.styleClass"
            [escape]="variant.escape"
            [autoHide]="variant.autoHide"
            [hideDelay]="200"
            tooltipEvent="hover"
          >
            {{ position.label }}
          </button>
        }
      </div>
    </div>
  }
</div>

<h3 class="modal-group-title">Directive options</h3>
<div class="tooltip-option-row">
  <div class="tooltip-option">
    <span class="tooltip-option-label">Hoverable template content</span>
    <svg
      lucideInfo
      class="tooltip-icon-host"
      [pTooltip]="tooltipTemplateContent"
      tooltipPosition="top"
      tooltipStyleClass="real-time-rpo-tooltip"
      tooltipEvent="hover"
      [autoHide]="false"
      [hideDelay]="200"
    ></svg>
    <span class="tooltip-option-note">
      ng-template body, <code>[autoHide]="false"</code> + <code>[hideDelay]="200"</code> — the cursor can travel into
      the bubble and click the link.
    </span>
  </div>
  <div class="tooltip-option">
    <span class="tooltip-option-label">Inside an overflow container</span>
    <div class="tooltip-overflow-host">
      <button type="button" class="tooltip-target" [pTooltip]="tooltipSampleArn" tooltipPosition="top" appendTo="body">
        appendTo="body"
      </button>
      <button type="button" class="tooltip-target" [pTooltip]="tooltipSampleArn" tooltipPosition="top">
        default host
      </button>
    </div>
    <span class="tooltip-option-note">
      Scrolling the container hides an open tooltip either way; the difference is whether the bubble can escape the
      clip.
    </span>
  </div>
  <div class="tooltip-option">
    <span class="tooltip-option-label">Inside a dialog</span>
    <button type="button" class="arpio-secondary-button" (click)="openTooltipInDialog()">Open dialog</button>
    <span class="tooltip-option-note">
      Dialogs take PrimeNG's deferred align path — the first measurement happens 100ms after the hover.
    </span>
  </div>
</div>

<ng-template #tooltipTemplateContent>
  <div class="tooltip-template-body">
    This application has realtime replication enabled. Real-time replication works for DynamoDB tables, EC2 instances,
    S3 buckets, and RDS DB clusters.
    <a href="javascript:void(0)" class="tooltip-template-link">Read more about real-time replication</a>
  </div>
</ng-template>

<modal-dialog #tooltipInDialog [dialogTemplate]="tooltipInDialogTpl"></modal-dialog>
<ng-template #tooltipInDialogTpl>
  <div class="flex-left-column light-control-host">
    <div class="modal-header">
      <h3 class="panel-title">Tooltips inside a dialog</h3>
      <button
        type="button"
        class="modal-close-btn"
        (click)="tooltipInDialog.close()"
        pTooltip="Close"
        tooltipPosition="left"
        aria-label="Close"
      >
        <svg lucideX></svg>
      </button>
    </div>
    <div class="tooltip-host-row">
      @for (position of tooltipPositions; track position.key) {
        <button type="button" class="tooltip-target" [pTooltip]="tooltipSampleArn" [tooltipPosition]="position.key">
          {{ position.label }}
        </button>
      }
    </div>
  </div>
</ng-template>
